<template>
<!-- 商品管理 -->
    <div class="el-card pd20">
        <div class="main">
            <!-- list-->
            <div class="el-card pd20">
                <el-table :data="list" show-overflow-tooltip border style="width: 100%">
                    <el-table-column type="index" width="50" label="序号"></el-table-column>
                    <el-table-column prop="id" label="活动ID"  width="80" > </el-table-column>
                    <el-table-column prop="name" label="活动名称"></el-table-column>
                    <el-table-column prop="link" label="活动链接" ></el-table-column>
                    <el-table-column label="操作" width="200">
                        <template slot-scope="scope">
                            <el-button type="primary" size="mini" icon="el-icon-edit" @click="editChannel(scope.$index, scope.row)">修改</el-button>
                            <el-button type="primary" icon="el-icon-picture-outline-round" @click="qrCoede(scope.$index, scope.row)" size="mini" >二维码</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 添加按钮 -->
            <el-button type="primary" class="addBtn" size="mini" icon="el-icon-circle-plus"  @click="editChannel()" circle></el-button>
            <!-- 分页 -->
            <el-pagination class="pages" 
                :page-sizes="[25, 50, 75, 100]"
                @size-change="handleSizeChange" 
                @current-change="handleCurrentChange" 
                :page-size="pages.size" 
                :current-page="pages.page"
                background 
                layout="sizes,prev, pager, next" 
                :total="pages.count"> 
            </el-pagination>
            <!-- -->
        </div>
        <el-dialog title="活动编辑" :visible.sync="activityBool">
            <el-form :model="form">
                <el-form-item label="渠道名称" :label-width="formLabelWidth">
                    <el-input v-model="form.name" placeholder="请输入活动名称" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="渠道链接" :label-width="formLabelWidth">
                    <el-input v-model="form.link" placeholder="请输入活动链接" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="activityBool = false">取 消</el-button>
                <el-button type="primary" @click="saveActivity()">确 定</el-button>
            </div>
        </el-dialog>
        <div v-show="false"  id="qrcode"></div>
    </div>
</template>

<script>
import JSZip from "jszip"
import FileSaver from "file-saver"
import { activityList,addActivity,updateActivity,getBaseUrl,sourceAll} from "@/api/career_college";
export default {
    data() {
        return{
            list: [],
            pages: {},
            obj:{},
            // 编辑
            activityBool:false,
            form:{
                name:'',
                link:null
            },
            formLabelWidth: '120px'
        }
    },
    methods:{
        /*
         *@param: 
         *@return: 
         *@Description: 二维码
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-03-08 13:28:00
        */
       qrCoede(index,row){
           this.$showLoading();
           // 获取全部渠道
            let sourceArr = [];
            Promise.all([
                sourceAll({
                    status:1
                }),
                getBaseUrl()
           ]).then((data)=>{
               sourceArr = data[0].list;
            //    存储生成二维码的链接
                let codeArr = [];
                sourceArr.forEach((item,index)=>{
                    // 生成二维码
                    let qrcode = new QRCode(document.getElementById("qrcode"),{
                        width: 100,
                        height: 100,
                    });
                    qrcode.makeCode(`${data[1].base_url+'?md5='+row.md5+'&sid='+item.id}`);
                    
                    let base64_ = qrcode._oDrawing._elCanvas.toDataURL("image/png").split(',')[1];
                    codeArr.push({
                        baseImg:base64_,
                        name:row.name+'_'+item.name
                    });
                    
                    
               });
               // 打包下载
                this.imgZip(codeArr);
               this.$hideLoading();
            }).catch((err)=>{
                this.$hideLoading();
            });

       },
    //    图片压缩
       imgZip(arr){
           // 初始化一个zip打包对象
            let zip = new JSZip();

            // 创建一个名为images的新的文件目录
            let img = zip.folder("images");
            arr.forEach((item,index)=>{
                // 这个images文件目录中创建一个base64数据为imgData的图像，图像名是smile.gif
                img.file(item.name+'.png', item.baseImg, {base64: true});
            });
            
            // 把打包内容异步转成blob二进制格式
            zip.generateAsync({
                type:"blob"
            }).then(function(content) {
                // content就是blob数据，这里以example.zip名称下载    
                // 使用了FileSaver.js  
                saveAs(content, `${new Date().toLocaleString()}活动二维码.zip`);
            });
       },
        // 提交编辑信息
        saveActivity(){
            this.$showLoading();
            if(this.form && this.form.id){
                updateActivity(this.form).then((data)=>{
                    if(data.error>0){
                        this.$message(data.detail || data.msg);
                        return
                    }
                    this.$notify({
                        title: '成功',
                        message: '修改成功！',
                        type: 'success'
                    });
                    this.pullData();
                    this.$hideLoading();
                }).catch((err)=>{
                    this.$hideLoading();
                });
            }else{
                addActivity(this.form).then((data)=>{
                    if(data.error>0){
                        this.$message(data.detail || data.msg);
                        return
                    }
                    this.$notify({
                        title: '成功',
                        message: '添加成功！',
                        type: 'success'
                    });
                    this.pullData();
                    this.$hideLoading();
                }).catch((err)=>{
                    this.$hideLoading();
                });
            }
            this.form = {
                name:'',
                status:null
            };
            this.activityBool = false;
        },
        /**
         * 编辑渠道
         */
        editChannel(index,row){
            if(row && row.id){
                this.form = row;
            }else{
                this.form = {
                    name:'',
                    status:null
                };
            }
            this.activityBool = true;
            
        },
         // 调整每页显示条数
        handleSizeChange(val) {
            this.pages.size = val;
            this.pullData();
        },
        // 触发分页
        handleCurrentChange(val) {
            this.pages.page = val;
            this.pullData();
        },
        pullData(){
            this.$showLoading();
            this.obj = {
                page:Object.keys(this.pages).length>0?this.pages.page:1,  //页码，默认1
                size:Object.keys(this.pages).length>0?this.pages.size:25   //每页数量，默认25
            };
            activityList(this.obj).then((data)=>{
                this.list = data.list;
                this.pages = data.pager;
                // 课程名称
                this.course_name_list = data.course;
                
                this.$hideLoading();
            }).catch((err)=>{
                this.$hideLoading();
            });
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.main{
  position: relative;
}
.addBtn{
  position: absolute;
  left: 0;
  bottom: 0;
}
.pages{
  text-align: right;
  margin-top: 30px;
}
.pages-box{
    height: 32px;
    margin-top: 30px;
}
.preview{
    width: 300px;
    border-radius: 5px;
}
.box{
    margin-bottom: 20px;
}
.search{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
}
.search.search-btn{
    flex: 1;
}
.search-gropu{
    flex: 1;
}
.search-gropu.on{
    flex: 1.5;
}
.search-child{
    margin-left: 20px;
    width: 200px;
}
.userinfo{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    img{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 15px;
    }
}
</style>